/* eslint-disable sonarjs/no-duplicate-string */
import { EndpointConfig, GlobalConfig, Method } from 'react-api-data'
import { State } from './state/state'
import { UserActionType, isLoggedIn } from './state/user'

const getUrl = (path: string) => `https://meting.backapps.nl${path}`

export const globalConfig: GlobalConfig = {
    setHeaders: (_defaultHeaders: Record<string, string>, state: State) => {
        const authorizationHeaders: {Authorization?: string} = {}
        if (isLoggedIn(state)) {
            authorizationHeaders.Authorization = `Bearer ${
                state.user.token ?? ''
            }`
        }
        return {
            ..._defaultHeaders,
            ...authorizationHeaders,
        }
    },
}

export const endpointConfig: Record<string, EndpointConfig> = {
    getMeasurement: {
        url: getUrl('/api/v1/measurement'),
        method: 'GET' as Method,
    },
    postMeasurement: {
        url: getUrl('/api/v1/measurement'),
        method: 'POST' as Method,
        afterSuccess: ({actions: {invalidateCache}}) => {
            invalidateCache('getMeasurement')
        },
    },
    getMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'GET' as Method,
    },
    putMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'PUT' as Method,
        afterSuccess: ({actions: {invalidateCache}}) => {
            invalidateCache('getMeasurement')
        },
    },
    deleteMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'DELETE' as Method,
        afterSuccess: ({actions: {invalidateCache}}) => {
            invalidateCache('getMeasurement')
        },
    },
    getUsers: {
        url: getUrl('/api/v1/users'),
        method: 'GET' as Method,
    },
    postUsers: {
        url: getUrl('/api/v1/users'),
        method: 'POST' as Method,
    },
    getUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'GET' as Method,
    },
    putUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'PUT' as Method,
    },
    deleteUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'DELETE' as Method,
    },
    postLogin: {
        url: getUrl('/api/v1/login'),
        method: 'POST' as Method,
    },
    postLogout: {
        url: getUrl('/api/v1/logout'),
        method: 'POST' as Method,
        afterSuccess: ({dispatch}) => {
            dispatch({type: UserActionType.logout})
            dispatch({type: 'PURGE_ALL_API_DATA'})
        },
    },
}

console.log(endpointConfig)